// API 配置文件 - 替换 Firebase
// 🔧 如需更换域名，只需修改下面的 PRODUCTION_DOMAIN 变量
const PRODUCTION_DOMAIN = 'enen.saitsuki.uk';

// 统一使用生产API
const API_BASE_URL = `https://${PRODUCTION_DOMAIN}/api`;

// API 端点配置
export const API_ENDPOINTS = {
  // 认证相关
  AUTH: {
    LOGIN: `${API_BASE_URL}/auth/login`,
    REGISTER: `${API_BASE_URL}/auth/register`,
    LOGOUT: `${API_BASE_URL}/auth/logout`,
    ME: `${API_BASE_URL}/auth/me`,
    USERS: `${API_BASE_URL}/auth/users`,
    CHANGE_PASSWORD: `${API_BASE_URL}/auth/change-password`,
    VERIFY_EMAIL: `${API_BASE_URL}/auth/verify-email`,
    RESEND_VERIFICATION: `${API_BASE_URL}/auth/resend-verification`,
    FORGOT_PASSWORD: `${API_BASE_URL}/auth/forgot-password`,
    RESET_PASSWORD: `${API_BASE_URL}/auth/reset-password`
  },
  
  // 验证码相关
  CAPTCHA: {
    GENERATE: `${API_BASE_URL}/captcha/generate`,
    VERIFY: `${API_BASE_URL}/captcha/verify`
  },
  
  // 通知相关
  NOTICES: {
    LIST: `${API_BASE_URL}/notices`,
    CREATE: `${API_BASE_URL}/notices`,
    UPDATE: (id) => `${API_BASE_URL}/notices/${id}`,
    DELETE: (id) => `${API_BASE_URL}/notices/${id}`,
    GET: (id) => `${API_BASE_URL}/notices/${id}`
  },
  
  // 文件上传
  UPLOAD: `${API_BASE_URL}/upload`,
  
  // 网站设置
  SETTINGS: {
    ALL: `${API_BASE_URL}/settings`,
    ACCESS: `${API_BASE_URL}/settings/access`
  },
  
  // 联系消息
  MESSAGES: {
    LIST: `${API_BASE_URL}/messages`,
    CREATE: `${API_BASE_URL}/messages`,
    UPDATE: (id) => `${API_BASE_URL}/messages/${id}`,
    DELETE: (id) => `${API_BASE_URL}/messages/${id}`,
    GET: (id) => `${API_BASE_URL}/messages/${id}`
  },
  
  // 页面内容管理
  PAGE_CONTENT: {
    PAGES: `${API_BASE_URL}/page-content/pages`,
    GET: (pageName) => `${API_BASE_URL}/page-content/${pageName}`,
    UPDATE: (pageName) => `${API_BASE_URL}/page-content/${pageName}`
  },
  
  // 课程报名相关
  COURSE_ENROLLMENT: {
    LIST: `${API_BASE_URL}/course-enrollment`,
    COURSES: `${API_BASE_URL}/course-enrollment/courses`,
    CREATE: `${API_BASE_URL}/course-enrollment`,
    ADMIN_LIST: `${API_BASE_URL}/course-enrollment/admin`,
    ADMIN_UPDATE: (id) => `${API_BASE_URL}/course-enrollment/admin/${id}`,
    ADMIN_DELETE: (id) => `${API_BASE_URL}/course-enrollment/admin/${id}`
  }
};

// HTTP 请求工具类
class ApiClient {
  constructor() {
    this.token = localStorage.getItem('auth_token');
  }
  
  // 设置认证 token
  setToken(token) {
    this.token = token;
    if (token) {
      localStorage.setItem('auth_token', token);
    } else {
      localStorage.removeItem('auth_token');
    }
  }
  
  // 获取请求头
  getHeaders(isFormData = false) {
    const headers = {};
    
    if (!isFormData) {
      headers['Content-Type'] = 'application/json';
    }
    
    if (this.token) {
      headers['Authorization'] = `Bearer ${this.token}`;
    }
    
    return headers;
  }
  
  // 处理响应
  async handleResponse(response) {
    if (!response.ok) {
      let errorMessage = `HTTP ${response.status}`;
      try {
        const backendError = await response.json();
        // 优先使用后端返回的 'message' 或 'error' 字段
        if (backendError && backendError.message) {
          errorMessage = backendError.message;
        } else if (backendError && backendError.error) {
          errorMessage = backendError.error;
        }
      } catch (e) {
        // 解析JSON失败，使用更通用的网络错误提示
        errorMessage = 'Network error or non-JSON response';
      }
      throw new Error(errorMessage);
    }
    return response.json();
  }
  
  // GET 请求
  async get(url) {
    const response = await fetch(url, {
      method: 'GET',
      headers: this.getHeaders()
    });
    
    return this.handleResponse(response);
  }
  
  // POST 请求
  async post(url, data, isFormData = false) {
    const body = isFormData ? data : JSON.stringify(data);
    
    const response = await fetch(url, {
      method: 'POST',
      headers: this.getHeaders(isFormData),
      body
    });
    
    return this.handleResponse(response);
  }
  
  // PUT 请求
  async put(url, data) {
    const response = await fetch(url, {
      method: 'PUT',
      headers: this.getHeaders(),
      body: JSON.stringify(data)
    });
    
    return this.handleResponse(response);
  }
  
  // DELETE 请求
  async delete(url) {
    const response = await fetch(url, {
      method: 'DELETE',
      headers: this.getHeaders()
    });
    
    return this.handleResponse(response);
  }
}

// 创建全局 API 客户端实例
export const apiClient = new ApiClient();

// 导出 API 基础 URL
export { API_BASE_URL }; 